var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1409_800)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.60847 29.5523C3.46335 31.6907 3.46334 36.3085 6.60847 38.447C19.7363 47.3731 29.6116 52.1554 34.6907 54.3366C37.5698 55.573 40.7744 53.984 41.5151 50.9307C41.9943 48.9553 42.5423 46.3414 42.9613 43.3347L51.1308 44.424C54.2572 44.8409 57.6048 43.1607 58.2065 39.6442C58.4647 38.1356 58.6576 36.2538 58.6576 33.9996C58.6575 31.7454 58.4647 29.8636 58.2065 28.355C57.6048 24.8385 54.2572 23.1584 51.1308 23.5752L42.9612 24.6645C42.5424 21.6578 41.9942 19.0439 41.5151 17.0685C40.7744 14.0153 37.5698 12.4263 34.6907 13.6627C29.6116 15.8439 19.7362 20.6263 6.60847 29.5523Z",
    fill: "#E8833A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1409_800"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.0234375 34) rotate(-45)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.25c928ad238bc0f9ce1e4180edaa2638.svg";
export { ForwardRef as ReactComponent };